import React from 'react'

function InsertEmail() {
  return (
    <div>CodePass</div>
  )
}

export default InsertEmail